// extracted by mini-css-extract-plugin
module.exports = {"alarm_close":"modal_alarm_close__bCLvi","alarm_modal":"modal_alarm_modal__QThNY","alarm_modal_lg":"modal_alarm_modal_lg__2JgZP","alarm_modal_bg":"modal_alarm_modal_bg__Ni1o9"};